"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro přístup k organizačním jednotkám. Generated from cz.marbes.api.organizace.v1.OrganizacniJednotkaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:56:16Z                      #

// ##############################################################

var OrganizacniJednotkaApi = function () {
  function OrganizacniJednotkaApi() {
    (0, _classCallCheck3.default)(this, OrganizacniJednotkaApi);
  }

  (0, _createClass3.default)(OrganizacniJednotkaApi, null, [{
    key: "getOrganizacniJednotkaById",

    /**
     * Vrátí organizační jednotku s daným ID
     *
     * @param id ID organizační jednotky
     * @return organizační jednotka
     */
    value: function getOrganizacniJednotkaById(id) {
      var uri = serverContextPath + ("/api/organizace/v1/organizacnijednotky/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí seznam všech organizačních jednotek
     *
     * @return seznam organizačních jednotek
     */

  }, {
    key: "getOrganizacniJednotky",
    value: function getOrganizacniJednotky() {
      var uri = serverContextPath + "/api/organizace/v1/organizacnijednotky";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí organizační jednotku s daným kódem
     *
     * @param kod kód organizační jednotky
     * @return organizační jednotka
     */

  }, {
    key: "getOrganizacniJednotkaByKod",
    value: function getOrganizacniJednotkaByKod(kod) {
      var uri = serverContextPath + ("/api/organizace/v1/organizacnijednotky/" + kod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return OrganizacniJednotkaApi;
}();

exports.default = OrganizacniJednotkaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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